import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, IconButton, Paper, Stack, TextField, Tooltip } from '@mui/material';
import { useController, useFormContext } from 'react-hook-form';
import { ProductPostAsset } from 'store/api/pages-api/pages-api-types';

import { styles } from './product-post.styles';

type Props = {
  productIdx?: number;
  assetIdx?: number;
  asset: ProductPostAsset;
  onDeleteButton?: () => void;
};

const ProductPost = ({ asset, assetIdx, productIdx, onDeleteButton = () => {} }: Props) => {
  const { control } = useFormContext();
  const textField = useController({
    control,
    name: `products.${productIdx}.productAssets.${assetIdx}.file_data.text`,
  });

  return (
    <Paper elevation={0} sx={styles.container}>
      <Box sx={styles.header}>
        <Box sx={styles.dragHandle}>
          <DragIndicatorIcon fontSize="small" />
        </Box>
        <Tooltip title="Remove">
          <IconButton color="error" onClick={onDeleteButton} size="small">
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Stack spacing={1.5} sx={styles.stack}>
        <Box
          alt={`product_${productIdx}_post_${assetIdx}`}
          component="img"
          src={asset.url || asset.preview}
          sx={{ height: 120, maxWidth: '100%', objectFit: 'contain', borderRadius: 1, flexShrink: 0 }}
        />

        <TextField
          fullWidth
          label="Text"
          multiline
          placeholder="Enter your simple wording"
          size="small"
          sx={styles.textField}
          {...textField.field}
          error={textField.fieldState.invalid}
          helperText={textField.fieldState.error?.message}
        />
      </Stack>
    </Paper>
  );
};

export { ProductPost };
